import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from 'core/icons';
import { RadioToggle } from 'core/controls';

class ConfigAssistantDriveToggle extends Component {
  renderLabel = option => {
    const rearWheelDescription = option.rearWheelType
      .replace('Rear Wheel', '')
      .trim();
    const iconName = option.icon
      .replace(/\..+$/, '')
      .replace(/_/g, '-')
      .toLowerCase();
    return (
      <Fragment>
        <SvgIcon
          name={iconName}
          className={`config-assistant-drive-type__icon ${option.iconClass ||
            ''}`}
        />
        <div>
          <div>{option.driveType}</div>
          <div>{rearWheelDescription}</div>
        </div>
      </Fragment>
    );
  };

  render() {
    const { options, selected, onChange } = this.props;
    return (
      <div className="config-assistant-drive-toggle">
        <RadioToggle
          options={options}
          renderLabel={this.renderLabel}
          selected={selected}
          onChange={onChange}
        />
      </div>
    );
  }
}

ConfigAssistantDriveToggle.propTypes = {
  selected: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      driveType: PropTypes.string.isRequired,
      rearWheelType: PropTypes.string.isRequired,
      icon: PropTypes.string,
      iconClass: PropTypes.string
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired
};

export default ConfigAssistantDriveToggle;
